import { useEffect, useState } from 'react';
import { NavLink, useSelector } from '../../imports/generalImport';
import { useDispatch } from 'react-redux';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import {
  Box,
  Container,
  IconButton,
  Typography,
} from '../../imports/muiImport';
import { fetchDashboardData } from '../../store/dashboard/action.js';
import NoImageAvailable from '../../assets/no-image-placeholder.png';
import { useRef } from "react";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

function CategorySection() {
  const dispatch = useDispatch();
  const category = useSelector(
    (state) => state?.Dashboard?.categories
  );
  const scrollRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  useEffect(() => {
    dispatch(fetchDashboardData());
  }, [dispatch]);

  const linkProps = (id) => ({
    pathname: '/card-list',
    search: `categoryIds[]=${id}`,
  });
  const link = () => ({
    pathname: '/card-list',

  });
  const scrollLeft = () => {
    scrollRef.current?.scrollBy({
      left: -300,
      behavior: "smooth",
    });
  };
  const scrollRight = () => {
    scrollRef.current?.scrollBy({
      left: 300,
      behavior: "smooth",
    });
  };
  const checkScrollPosition = () => {
    const el = scrollRef.current;

    if (!el) return;

    setCanScrollLeft(el.scrollLeft > 0);

    setCanScrollRight(
      el.scrollLeft < el.scrollWidth - el.clientWidth - 5
    );
  };
  useEffect(() => {
    checkScrollPosition();
  }, [category]);
  useEffect(() => {
    const el = scrollRef.current;

    if (!el) return;

    el.addEventListener("scroll", checkScrollPosition);

    return () => {
      el.removeEventListener("scroll", checkScrollPosition);
    };
  }, []);

  return (
    <Container maxWidth={false} disableGutters sx={{ mt: { xs: 3, md: 5 } }}>
      {/* Header */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2,


        }}
      >

        <Typography
          sx={{
            fontSize: { xs: '16px', sm: '24px', md: '30px' },
            fontWeight: 500,
            fontFamily: 'Be Vietnam Pro',
            color: 'primary.main',
          }}
        >
          Shop By Categories
        </Typography>
        <Typography
          component={NavLink}
          to={link()}
          sx={{
            fontSize: { xs: '12px', sm: '16px' },
            color: '#000',
            fontWeight: 500,
            textDecoration: 'none',
            display: 'flex',
            alignItems: 'center',
            '& svg': {
              fontSize: { xs: '13px', sm: '16px' },
              ml: 0.5,
              transition: '0.3s',
            },

            '&:hover svg': {
              transform: 'translate(3px, -3px)',
            },
          }}
        >
          View All <ArrowOutwardIcon />
        </Typography>

      </Box>

      <Box sx={{ position: "relative" }}>

        <IconButton
          onClick={scrollLeft}
          disabled={!canScrollLeft}
          disableRipple
          disableFocusRipple
          sx={{
            display: { xs: "none", sm: "flex" },
            position: "absolute",
            left: -22,
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 5,
            bgcolor: "secondary.main",
            color: "#FFF",
            boxShadow: 2,
            opacity: canScrollLeft ? 1 : 2,

            "&:hover": {
              bgcolor: "secondary.main",
              boxShadow: 2,
            },

            "&:active": {
              bgcolor: "secondary.main",
            },

            "&.Mui-focusVisible": {
              bgcolor: "secondary.main",
            },
             "&.Mui-disabled": {
             bgcolor: "#F5F5F5",
              color: "#BDBDBD"

            },
          }}
        >
          <ArrowBackIosNewIcon sx={{ fontSize: 24 }} />
        </IconButton>

        {/* Categories */}
        <Box
          ref={scrollRef}
          sx={{
            display: "flex",
            overflowX: "auto",
            gap: { xs: 1.5, md: 2.7 },
            pb: 1,
            scrollBehavior: "smooth",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
        >
          {[...(category || [])].reverse().map((item) => (
            <Box
              key={item?.id}
              component={NavLink}
              to={linkProps(item?.id)}
              sx={{
                flexShrink: 0,
                width: {
                  xs: "43%",
                  sm: "calc(30% - 14px)",
                  md: "calc(25% - 14px)",
                  lg: "calc(20% - 16px)",
                  xl: "calc(16.66% - 18px)",
                },
                borderRadius: "18px",
                background: "#fff",
                transition: "0.3s",
                textDecoration: "none",
              }}
            >
              <Box
                sx={{
                  position: "relative",
                  width: "100%",
                  height: {
                    xs: 200,
                    sm: 220,
                    md: 260,
                    lg: 280,
                  },
                  borderRadius: 3,
                  overflow: "hidden",
                }}
              >
                <Box
                  component="img"
                  src={item?.logo || NoImageAvailable}
                  alt={item?.name}
                  sx={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />

                <Box
                  sx={{
                    position: "absolute",
                    bottom: 0,
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    pb: 1,
                    gap: 0.7,
                  }}
                >
                  <Typography
                    fontWeight={700}
                    sx={{
                      color: "#0B0B4F",
                      fontSize: {
                        xs: "10.5px",
                        sm: "11px",
                        md: "13.5px",
                      },
                      textTransform: "capitalize",
                      fontFamily: "Be Vietnam Pro",
                      textAlign: "center",
                    }}
                  >
                    {item?.name}
                  </Typography>

                  <Box
                    sx={{
                      background:
                        "linear-gradient(270deg, #B37B30 0%, #E6B655 100%)",
                      borderRadius: "8px",
                      color: "#fff",
                      px: { xs: 2, sm: 3 },
                      py: { xs: 0.5, sm: 0.6 },
                      fontSize: { xs: "9px", sm: "13px" },
                      fontFamily: "Be Vietnam Pro",
                    }}
                  >
                    View Gift Cards
                  </Box>
                </Box>
              </Box>
            </Box>
          ))}
        </Box>

        {/* Right Arrow */}
        <IconButton
          onClick={scrollRight}
          disabled={!canScrollRight}
          sx={{
            display: { xs: "none", sm: "flex" },
            position: "absolute",
            right: -22,
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 5,
            bgcolor: "secondary.main",
            color: "#FFF",
            boxShadow: 2,
            opacity: canScrollRight ? 1 : 2,

            "&:hover": {
              bgcolor: "secondary.main",
              boxShadow: 2,
            },

            "&:active": {
              bgcolor: "secondary.main",
            },

            "&.Mui-focusVisible": {
              bgcolor: "secondary.main",
            },
            "&.Mui-disabled": {
             bgcolor: "#F5F5F5",
              color: "#BDBDBD"

            },

          }}
        >
          <ArrowForwardIosIcon sx={{ fontSize: 24 }} />
        </IconButton>
      </Box>

    </Container>
  );
}

export default CategorySection;